import { FrontYardCreate } from "../organism";
import { DefaultPage } from "./";

const links = [
  {
    title: "Home",
    to: "/realestate"
  },
  {
    title: "FrontYard",
    to: "/realestate/frontyard"
  },
  {
    title: "Create"
  }
];

const FrontYardCreatePage = (props) => {
  return (<>
    <DefaultPage pathname={props.location.pathname} links={links}>
      <FrontYardCreate history={props.history} />
    </DefaultPage>
  </>);
};

export { FrontYardCreatePage };
